import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { ISearchItemsGroup } from './../../../../../common/interfaces/search';
import { PortalSearchItem } from '.';

// Styles
const s = require('./PortalSearchTable.css');

// Props
interface IPortalSearchTableProps {
    userPermissionId: number;
    inventoryOnRight: boolean;
    cart: ISearchItemsGroup;
}

// Component
@observer
export class PortalSearchTable extends React.Component<IPortalSearchTableProps, {}> {
    static get defaultProps(): IPortalSearchTableProps {
        return {
            userPermissionId: 0,
            inventoryOnRight: false,
            cart: null
        };
    }

    public render() {
        return (
            <div className={s.container}>

                <div className={s.header}>
                    <div className={s.carModel}>
                        <h3>{this.props.cart.concat}</h3>
                    </div>
                    <div className={s.partDetails}>
                        <p>Part details</p>
                    </div>
                    <div
                        className={classNames(s.inventory, s.center, {
                            [s.right]: this.props.inventoryOnRight
                        })}
                    >
                        <p>Inventory</p>
                    </div>
                    {(this.props.userPermissionId >= 2) && (
                        <div className={classNames(s.price, s.right)}>
                            <p>Price</p>
                        </div>
                    )}
                    {(this.props.userPermissionId >= 3) && (
                        <div className={classNames(s.order, s.right)}>
                            <p>Order</p>
                        </div>
                    )}
                </div>

                {(this.props.cart.items.map((item, itemIndex) => (
                    <PortalSearchItem
                        key={`item-${item.id}`}
                        id={itemIndex}
                        item={item}
                    />
                )))}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalSearch/PortalSearchTable.tsx